import { render, staticRenderFns } from "./UpsellCard.vue?vue&type=template&id=b8a9f244&scoped=true"
import script from "./UpsellCard.vue?vue&type=script&lang=js"
export * from "./UpsellCard.vue?vue&type=script&lang=js"
import style0 from "./UpsellCard.vue?vue&type=style&index=0&id=b8a9f244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a9f244",
  null
  
)

export default component.exports